import { CasinoStatus, ListMode } from "./CasinoReducer";
import { Dispatch } from "redux";
import { getContainer } from "../ioc/IOCSetup";
import { AppState } from "../RootReducer";
import { CasinoGame, CasinoLobby, CasinoLobbyCategory } from "../http/protocol";
import { Container } from "react-bootstrap";

export enum CasinoActionTypes {
    SELECT_CATEGORY = "@casino/category/select",
    GAMES_REQUEST = "@casino/games/request",
    GAMES_RESPONSE = "@casino/games/response",
    GAMES_ERROR = "@casino/games/error",
    SELECT_LIST_MODE = "@casino/list/mode",
    UPDATE_SEARCH_VALUE = "@casino/update/search",
    SET_PLAYED_GAMES = "@casino/set/games",
    SET_FAVOURITE_GAMES = "@casino/set/favourite",
    SELECT_STUDIO = "@casino/selec/studio",
    SELECT_CATEGORY_NAME = "@casino/selected/categories",
}
export type CasinoAction =
    | { type: CasinoActionTypes.GAMES_RESPONSE, lobby: CasinoLobby }
    | { type: CasinoActionTypes.SELECT_CATEGORY, category: number }
    | { type: CasinoActionTypes.GAMES_ERROR, error: Error }
    | { type: CasinoActionTypes.GAMES_REQUEST }
    | { type: CasinoActionTypes.SELECT_LIST_MODE, mode: ListMode }
    | { type: CasinoActionTypes.UPDATE_SEARCH_VALUE, value: string }
    | { type: CasinoActionTypes.SET_PLAYED_GAMES, GameIds: number[] }
    | { type: CasinoActionTypes.SET_FAVOURITE_GAMES, GameIds: number[] }
    | { type: CasinoActionTypes.SELECT_STUDIO, studioName: string }
    | { type: CasinoActionTypes.SELECT_CATEGORY_NAME, categoryName: string }


export const selectStudio = (studioName: string) => (
    { type: CasinoActionTypes.SELECT_STUDIO, studioName: studioName }
)
export const selectCategory = (category: number) => (
    { type: CasinoActionTypes.SELECT_CATEGORY, category: category }
)
export const selectCategoryName = (category: string) => (

    { type: CasinoActionTypes.SELECT_CATEGORY_NAME, categoryName: category }
)
const RECENTLY_PLAYED_GAMES_KEY = "recentlyPlayedGames";
const FAVOURITE_GAMES_KEY = "favouriteGames";

export const addPlayedGame = (GameIdStr: string) => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let GameId = GameIdStr;
        let games = getState().casino.recentlyPlayedGames;
        console.log("add played games " + GameId, games);
        if (games) {
            let update = games.filter(g => g != GameId).slice(0, Math.min(5, games.length));
            games = Array.of(GameId).concat(update);
            dispatch({ type: CasinoActionTypes.SET_PLAYED_GAMES, GameIds: games });
            localStorage.setItem(RECENTLY_PLAYED_GAMES_KEY, JSON.stringify(games));
        }

    }
}
export const toggleFavouriteGame = (GameId: string) => {
    return (dispatch: Dispatch, getState: () => AppState) => {
        let games = getState().casino.favouriteGames;
        console.log("toggle favourite = ", GameId, games);
        if (games) {
            let update = games.filter(g => g != GameId);
            if (games.length == update.length) {
                update = update.concat([GameId]);
            }
            dispatch({ type: CasinoActionTypes.SET_FAVOURITE_GAMES, GameIds: update });
            localStorage.setItem(FAVOURITE_GAMES_KEY, JSON.stringify(update));
        }

    }
}
export const loadRecentlyPlayedGames = () => {

    try {
        let games = localStorage.getItem(RECENTLY_PLAYED_GAMES_KEY);
        if (games && games.length > 0) {
            let GameIds: number[] = JSON.parse(games);
            return { type: CasinoActionTypes.SET_PLAYED_GAMES, GameIds: GameIds };
        }
    } catch (e) {
        console.log("Unable to parse recently played games");
    }

    return { type: CasinoActionTypes.SET_PLAYED_GAMES, GameIds: [] };
}
export const loadFavouriteGames = () => {
    try {
        let favourites = localStorage.getItem(FAVOURITE_GAMES_KEY);
        if (favourites && favourites.length > 0) {
            let GameIds: number[] = JSON.parse(favourites);
            return { type: CasinoActionTypes.SET_FAVOURITE_GAMES, GameIds: GameIds };
        }
    } catch (e) {
        console.log("Unable to parse recently played games");
    }

    return { type: CasinoActionTypes.SET_FAVOURITE_GAMES, GameIds: [] };

}
export const requestGames = () => (
    { type: CasinoActionTypes.GAMES_REQUEST }
)
export const gamesResponse = (lobby: CasinoLobby) => (
    { type: CasinoActionTypes.GAMES_RESPONSE, lobby: lobby }
)
export const gamesError = (error: Error) => (
    { type: CasinoActionTypes.GAMES_ERROR, error: error }
)
export const selectListMode = (mode: ListMode) => (
    { type: CasinoActionTypes.SELECT_LIST_MODE, mode: mode }
);
export const updateSearchValue = (value: string) => (
    { type: CasinoActionTypes.UPDATE_SEARCH_VALUE, value: value }
);


export const loadCasinoGames = () => {
    return async (dispatch: Dispatch, getState: () => AppState) => {
        setTimeout(() => dispatch(loadRecentlyPlayedGames()));
        setTimeout(() => dispatch(loadFavouriteGames()));
        if (getState().casino.status != CasinoStatus.DONE) {
            dispatch(requestGames());
            try {
                let games = await getContainer().getCasinoService().getCasinoGames();
                dispatch(gamesResponse(games));
            } catch (e) {
                dispatch(gamesError(e));
            }
        }


    }
}

function hasId(id?: number, ids?: number[]) {
    if (!id || !ids) {
        return false;
    }
    return ids.some(i => i == id);
}

export function extractGamesByCategory(cat: CasinoLobbyCategory, games: CasinoGame[], mobile: boolean) {

    let favourites = localStorage.getItem(FAVOURITE_GAMES_KEY);

    let filteredGames = games.filter(g => {
        
        // if(mobile == true) {
        //     if(g.isMobile) {
        //         return true;
        //     }
        // } else if(mobile == false) {
        //     if(!g.isMobile && mobile == false) {
        //         return true;
        //     }
        // }
        //DESKTOP MODE CASINO GAMES
 let catID = cat.Id &&cat.Id.toString();
        if(cat.Name === "All Games") {
            return true
              //@ts-ignore
        }else if(cat.Id && g.Categories && g.Categories.includes(catID)) {
            return true;
        } else {
            return false;
        }
      
        
    });
    return filteredGames;
}